import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import "../styles/style__vaprobacion.css"; // Importamos el archivo CSS
import MenuPanel from "./menu.js"; // Nombre en mayúscula
import useUsers from "../hooks/useUsers.js";
import useImageModal from "../hooks/useImageModal.js";
import "../styles/style__imagemodal.css";
import volante from "../assets/boton_juego/coche-ganador.png"; // Importar la imagen
import Confetti from "react-confetti";

import {
  fetchsearchUser,
  fetchUsersDashboard,
  fetchWinner,
  fetchApproveUser,
} from "../services/serviceUser.js";
import { sendEmail } from "../services/serviceConfig.js";
import useConfiguracionFecha from "../hooks/useConfiguracionFecha.js";
import Alerta from "./alerta.js";

// Para que funcione el modal en la raíz
Modal.setAppElement("#root");

const TablaUsuarios = ({ user }) => {
  const [modalImage, setModalImage] = useState(null);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const [showConfetti, setShowConfetti] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const {
    formattedTime,
    modalConfiguracion,
    setModalConfiguracion,
    fechaEvento,
    horaEvento,
    abrirConfiguracionFecha,
    handleActualizarConfiguracion,
  } = useConfiguracionFecha();
  const [dashboard, setdashboard] = useState({}); // Para almacenar la opción seleccionada
  const [fecha, setFecha] = useState("");

  const [ganador, setGanador] = useState("Aun no hay un ganador");
  const {
    seleccionado,
    usuario,
    modalImagen,
    abrirImagenModal,
    cerrarImagenModal,
  } = useImageModal();

  const [razon, setRazon] = useState(""); // Estado para el valor del textarea
  useEffect(() => {
    // Activar confeti al cargar
    console.log("AY GANADOR?" + ganador);
    if (ganador && ganador.includes("Has ganado")) {
      setShowConfetti(true);

      // Capturar tamaño de ventana para el confeti
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      window.addEventListener("resize", handleResize);
    }

    // Opcional: detener confeti después de unos segundos
    // const timer = setTimeout(() => setShowConfetti(false), 5000);

    // return () => {
    //   clearTimeout(timer);
    //   window.removeEventListener("resize", handleResize);
    // };
  }, [ganador]);
  const [jugadoresVivos, setjugadoresVivos] = useState(0);
  const handleSendEmail = async (custom_id, razon) => {
    console.log(custom_id);
    try {
      const response = await sendEmail(custom_id, razon);

      if (response.success) {
        console.log(response.message);
      } else {
        console.log("Error: " + response.error);
      }
    } catch (error) {
      console.log("Hubo un error al enviar el correo: " + error.message);
    }
    setRazon("");
  };

  const [perdedores, setPerdedores] = useState(0);
  const [winner, setWinner] = useState(0);

  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const userData = await fetchUsersDashboard();
        console.log(userData);
        setdashboard(userData);
      } catch (err) {
        console.log("Hubo un error al obtener los datos del dashboard");
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    const fetchWinnerData = async () => {
      try {
        const winner = await fetchWinner();
        setWinner(winner);
      } catch (err) {
        console.log("Hubo un error al obtener el ganador");
      }
    };

    fetchWinnerData();
  }, []);
  const handleSearch = async (event) => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query.length > 2) {
      // Evita llamadas innecesarias con strings muy cortos
      const result = await fetchsearchUser(query);
      if (result) {
        setUsers(result);
      } else {
        setError("Error al buscar usuarios");
      }
    } else {
      refetch();
    }
  };
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
    setModalOpen(true);
  };

  // Función para cerrar el modal
  const closeModal = () => {
    setModalOpen(false);
    setModalImage(null);
  };

  const { users, setUsers, error, setError, refetch } = useUsers();
  const [configuracionActualizada, setConfiguracionActualizada] =
    useState(false);
  const actualizarFecha = async (event) => {
    event.preventDefault(); // Prevenir el comportamiento predeterminado de enviar el formulario
    const dateInput = event.target.dateInput.value;
    const timeInput = event.target.timeInput.value;
    const result = await handleActualizarConfiguracion(dateInput, timeInput);
    if (result) {
      setConfiguracionActualizada(true);
    }
  };

  const [selectedUsers, setSelectedUsers] = useState([]);
  const aprobarUsuario = async (user, esta_aprobado) => {
    try {
      const result = await fetchApproveUser(user, esta_aprobado);
      console.log("Resultado:", result);
      refetch();
    } catch (error) {
      setError(error.message);
      console.error("Error:", error);
    }
  };
  const handleCheckboxChange = (userId) => {
    setSelectedUsers(
      (prevSelected) =>
        prevSelected.includes(userId)
          ? prevSelected.filter((id) => id !== userId) // Deseleccionar
          : [...prevSelected, userId] // Seleccionar
    );
  };

  if (error) {
    return <div>{error}</div>;
  }
  const headerStyle = {
    padding: "8px",
    textAlign: "left",
    color: "#1c232b",
    height: "70px",
    fontFamily: "'Poppins', sans-serif", // Fuente Poppins
    fontWeight: "450",
    fontSize: "14px",
    textAlign: "center",
    borderBottom: "2px solid #8f9ac7",
  };

  const cellStyle = {
    fontFamily: "'Poppins', sans-serif", // Fuente Poppins
    fontSize: "14px",
    textAlign: "center",
    padding: "8px",
  };

  // Si tableData no es un array, no intenta mapear
  return (
    <div className="Aprobacion background__color flex__column">
      {showConfetti && (
        <Confetti width={windowSize.width} height={windowSize.height} />
      )}
      <MenuPanel abrirConfiguracion={abrirConfiguracionFecha} />
      {configuracionActualizada && (
        <Alerta type="success" message="Has cambiado la fecha del evento." />
      )}
      <div className="conjunto__estadisticas background__transparent">
        <div className="estadisticas background__white radius__10px first__font size__14px width__fullp">
          <h4 className="">
            <i class="bi bi-check-circle"></i> Aprobados
          </h4>
          <h5 className="font__weight600 size__24px margin__0 color__exito">
            {dashboard.approved_users}
          </h5>
          <p className="color__icons"> Cantidad aprobados</p>
        </div>
        <div className="estadisticas background__white radius__10px first__font size__14px width__fullp">
          <h4 className="">
            <i class="bi bi-play-circle"></i> En linea
          </h4>
          <h5 className="font__weight600 size__24px margin__0">
            {dashboard.active_connections}{" "}
          </h5>
          <p className="color__icons">Cantidad jugando</p>
        </div>{" "}
        <div className="estadisticas background__white radius__10px first__font size__14px width__fullp">
          <h4 className="">
            <i class="bi bi-x-circle"></i> Perdieron
          </h4>
          <h5 className="font__weight600 size__24px margin__0 color__fallo">
            {dashboard.inactive_connections}{" "}
          </h5>
          <p className="color__icons"> Cantidad perdieron</p>
        </div>{" "}
        <div className="estadisticas background__white radius__10px first__font size__14px width__fullp">
          <h4 className="">
            <i class="bi bi-people"></i> Total
          </h4>
          <h5 className="font__weight600 size__24px margin__0">
            {dashboard.total_users}{" "}
          </h5>
          <p className="color__icons">Total Jugadores</p>
        </div>
      </div>
      <div>
        <h2>El ganador es: </h2>
        <div className="ganador_container flex__row background__ganador radius__5px">
          {" "}
          <img src={volante} alt="img-coche" />{" "}
          <div className="flex__column all__centered ">
            {" "}
            <h3>{winner?.email || ganador || "No hay ganador aún"}</h3>
          </div>
        </div>
      </div>
      <div className="TablaAprobados background__white radius__10px">
        <div className="encabezadoAprobacion flex__column align__center DatosPrincipalesAprobados justify__between align__center">
          <div className="flex__row  justify__start width__fullp">
            <h1 className="first__font selfalign__start font__weight500 size__16px">
              Listado Participantes
            </h1>
          </div>
          <div className="search-bar width__fullp position__relative flex__row justify__between">
            <div>
              <input
                type="text"
                onChange={handleSearch}
                className="input-buscador background__color border__none first__font  justify__between"
                placeholder="Buscar participantes..."
                style={{
                  marginBottom: "16px",
                  borderRadius: "5px",
                }}
              />{" "}
              <button
                value={searchQuery}
                className="boton-buscador position__absolute background__transparent border__none radius__5x"
              >
                <i class="bi bi-search"></i>
              </button>
            </div>
            <div className="select-filtros">
              {/* <select
                id="opciones"
                name="opciones"
                className="background__color border__none first__font"
              >
                <option value="1">Aprobados</option>
                <option value="2">Rechazados</option>
              </select> */}
            </div>
          </div>
        </div>

        {/* Buscador */}

        <table
          style={{
            borderCollapse: "collapse",
            width: "100%",
            borderRadius: "10px",
          }}
          className="radius__10px esconder-tabla"
        >
          <thead
            className="titulo-tabla text__uppercase"
            style={{
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <tr
              style={{
                borderTopLeftRadius: "10px",
              }}
            >
              {" "}
              <th
                style={{
                  ...headerStyle,
                  borderTopLeftRadius: "10px",
                  backgroundColor: "#f3f5f7", // Fondo blanco
                }}
              ></th>
              <th style={headerStyle}> Nombre Completo</th>
              <th style={headerStyle}>Correo</th>
              <th style={headerStyle} className="datos-menos-relevantes">
                Whatsapp
              </th>
              <th style={headerStyle} className="datos-menos-relevantes">
                Instagram
              </th>
              <th style={headerStyle}>Fecha Creado</th>
              <th style={headerStyle}>Aprobación/Rechazo</th>
              <th
                style={{
                  ...headerStyle,
                  borderTopRightRadius: "10px",
                }}
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(users) && users.length > 0 ? (
              users.map((user, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid transparent",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      ...cellStyle,
                    }}
                  >
                    <div class="checkbox-wrapper-46">
                      <input
                        className="inp-cbx"
                        type="checkbox"
                        id={`checkbox-${user.id}`}
                        checked={selectedUsers.includes(user.id)}
                        onChange={() => handleCheckboxChange(user.id)}
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    <label
                      htmlFor={`checkbox-${user.id}`}
                      style={{ marginLeft: "8px" }}
                    >
                      {/* Aquí puedes poner el nombre u otros detalles del usuario */}
                    </label>
                  </td>
                  <td
                    style={{
                      ...cellStyle,
                    }}
                  >
                    {user.name}{" "}
                  </td>
                  <td style={cellStyle}>{user.email}</td>
                  <td style={cellStyle} className="datos-menos-relevantes">
                    {user.whatsapp}
                  </td>
                  <td style={cellStyle} className="datos-menos-relevantes">
                    {user.instagram}
                  </td>
                  <td style={cellStyle}>{user.date_joined}</td>{" "}
                  <td
                    style={{
                      ...cellStyle,
                    }}
                    className=""
                  >
                    <div className="acciones-vista flex__row all__centered">
                      {" "}
                      <button
                        className="background__third radius__5px flex__row color__white font__weight500 border__none first__font border__none "
                        onClick={() => abrirImagenModal(user)}
                      >
                        <i class="bi bi-image"></i>
                        <p className="margin__0">Datos Usuario</p>
                      </button>
                    </div>
                  </td>
                  <td style={cellStyle}>
                    <button
                      onClick={() => {
                        aprobarUsuario(user.id, true);
                      }}
                      className={`${
                        user.is_approved === true
                          ? "background__exito color__white"
                          : "background__disabled color__icons border__icons1px"
                      }  acciones-aprobacion  border__none color__white radius__5px size__18px`}
                    >
                      <i class="bi bi-check text-success"></i>
                    </button>
                    <button
                      onClick={() => {
                        aprobarUsuario(user.id, false);
                      }}
                      className={`${
                        user.is_approved === false
                          ? "background__fallo color__white"
                          : "background__disabled color__icons border__icons1px"
                      } acciones-aprobacion  border__none color__white radius__5px size__18px`}
                    >
                      <i class="bi bi-x text-danger"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={cellStyle}>
                  No hay datos disponibles.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Modal
          className="Modal_VerConfiguracion"
          isOpen={modalConfiguracion}
          onRequestClose={() => setModalConfiguracion(false)}
          contentLabel="Imagen Modal"
          style={{
            content: {
              backgroundColor: "#fff", // Color de fondo del modal
              borderRadius: "8px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
            },
            overlay: {
              display: "flex",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.8)", // Fondo oscuro con opacidad
              backdropFilter: "blur(10px)", // Efecto blur
            },
          }}
        >
          <div className="flex__row justify__between">
            {" "}
            <h2 className="first__font font__weight500 size__16px">
              Fecha del evento
            </h2>{" "}
            <button
              onClick={() => setModalConfiguracion(false)}
              className="background__transparent border__none font__weight500"
            >
              <i class="bi bi-x-lg"></i>{" "}
            </button>
          </div>
          <div className="flex__row all__centered">
            <div className="tiempo_evento flex__row justify__between">
              <div>
                <h4 className="margin__0">Fecha evento:</h4>
                <p className="margin__0">{fechaEvento}</p>
              </div>
              <div>
                <h4 className="margin__0">Hora evento:</h4>
                <p className="margin__0">{horaEvento}</p>
              </div>
            </div>
          </div>
          <form
            onSubmit={actualizarFecha}
            className="HorarioActividad flex__column justify__start align__center"
          >
            <div className="flex__column align__start">
              <label
                htmlFor="dateInput"
                className="first__font font__weight500"
              >
                Fecha:
              </label>
              {/* <input
                id="dateInput"
                className="background__second border__none radius__10px"
                type="text"
                placeholder={fecha || "Selecciona una fecha"}
                onFocus={() => isIOS && setIsFocused(true)} // Forzar foco en iOS
                onClick={() =>
                  document.getElementById("realDateInput").showPicker()
                } // Abre el picker manualmente
                readOnly
              /> */}
              <input
                id="dateInput"
                className="background__second radius__10px border__none"
                type="date"
                onChange={(e) => setFecha(e.target.value)}
              />
            </div>

            {/* Input de hora */}
            <div className="flex__column">
              <label
                className="first__font font__weight500"
                htmlFor="timeInput"
              >
                Hora:
              </label>
              <input
                id="timeInput"
                className="background__second radius__10px border__none"
                type="time"
                placeholder={formattedTime}
              />
            </div>
            <button
              // onClick={actualizarFecha()}
              type="submit"
              className="background__first first__font color__white border__none radius__10px justify__start "
            >
              Guardar
            </button>
          </form>
        </Modal>
        {/* Modal para Ver Imagenes */}
        <Modal
          className="Modal_VerDatos"
          isOpen={modalImagen}
          onRequestClose={() => abrirImagenModal(user)}
          contentLabel="Imagen Modal"
          style={{
            content: {
              backgroundColor: "#fff", // Color de fondo del modal
              borderRadius: "8px",
              padding: "20px",
            },
            overlay: {
              display: "flex",
              justifyContent: "center",
              backgroundColor: "rgba(0, 0, 0, 0.8)", // Fondo oscuro con opacidad
              backdropFilter: "blur(10px)", // Efecto blur
            },
          }}
        >
          <div className="flex__row justify__between">
            {" "}
            <h2 className="first__font font__weight500 size__14px">
              Datos Jugador{" "}
            </h2>{" "}
            <button
              onClick={() => cerrarImagenModal(user)}
              className="background__transparent border__none font__weight500"
            >
              <i class="bi bi-x-lg"></i>{" "}
            </button>
          </div>
          <div>
            <div className="flex__column">
              <p className="first__font font__weight500">Nombre completo</p>{" "}
              <div className="datousuario background__second radius__10px">
                {" "}
                <p>{usuario?.name ? usuario.name : "No tiene datos"}</p>
              </div>
            </div>{" "}
            <div className="flex__column">
              <p className="first__font font__weight500">Email</p>{" "}
              <div className="datousuario background__second radius__10px">
                {" "}
                <p>{usuario?.email ? usuario.email : "No tiene datos"}</p>
              </div>
            </div>{" "}
            <div className="flex__column">
              <p className="first__font font__weight500">Whatsapp</p>{" "}
              <div className="datousuario background__second radius__10px">
                {" "}
                <p>
                  {usuario?.whatsapp ? usuario.whatsapp : "No tiene datos"}{" "}
                </p>
              </div>
            </div>{" "}
            <div className="flex__column">
              <p className="first__font font__weight500">Instagram</p>{" "}
              <div className="datousuario background__second radius__10px">
                {" "}
                <p>
                  {usuario?.instagram ? usuario.instagram : "No tiene datos"}{" "}
                </p>
              </div>
            </div>{" "}
            <div className="flex__column">
              <p className="first__font font__weight500">Referencia Bancaria</p>{" "}
              <div className="datousuario background__second radius__10px">
                {" "}
                <p>{usuario?.pagoRef ? usuario.pagoRef : "No tiene datos"} </p>
              </div>
            </div>{" "}
          </div>
          <div className="flex__column justify__around align__center">
            <div className="flex__row seleccion_imagenes">
              {" "}
              {seleccionado?.archivo_seguidos ? (
                <div className="comprobantes">
                  {" "}
                  <img
                    src={seleccionado?.archivo_seguidos}
                    alt="Imagen de archivo"
                    onClick={() => openModal(seleccionado?.archivo_seguidos)}
                    style={{ cursor: "pointer" }} // Cambia el cursor para mostrar que es interactivo
                  />
                </div>
              ) : (
                <p>No hay imagen disponible</p>
              )}{" "}
              {seleccionado?.archivo_yappy ? (
                <div className="comprobantes">
                  <img
                    src={seleccionado?.archivo_yappy}
                    alt="Imagen de archivo"
                    onClick={() => openModal(seleccionado?.archivo_yappy)}
                    style={{ cursor: "pointer" }} // Cambia el cursor para mostrar que es interactivo
                  />
                </div>
              ) : (
                <p>No hay imagen disponible</p>
              )}{" "}
            </div>

            <div className="flex__column width__fullp">
              {" "}
              <h5 className="size__16px first__font">
                Razón o motivo de rechazo
              </h5>{" "}
              <textarea
                value={razon} // Asociamos el estado al textarea
                onChange={(e) => setRazon(e.target.value)} // Actualizamos el estado cada vez que cambie
                required
                className="width__fullp"
              ></textarea>
            </div>
            <div>
              <button
                onClick={() => {
                  aprobarUsuario(usuario?.id, true);
                  handleSendEmail(
                    usuario?.id,
                    "Tu usuario ha sido aprobado para participar en el evento. Te esperamos."
                  );
                }}
                className={`${
                  usuario?.is_approved === true
                    ? "background__exito color__white"
                    : "background__disabled color__icons border__icons1px"
                } width__fullp acciones-aprobacion  border__none  radius__5px size__18px`}
              >
                <i class="bi bi-check text-success"></i>
              </button>
              <button
                onClick={() => {
                  aprobarUsuario(usuario?.id, false);
                  handleSendEmail(usuario?.id, razon);
                }}
                className={`${
                  usuario?.is_approved == false
                    ? "background__fallo"
                    : "background__disabled color__icons border__icons1px"
                } acciones-aprobacion border__none color__white radius__5px size__18px`}
              >
                <i class="bi bi-x text-danger"></i>
              </button>
            </div>
            {modalOpen && (
              <div className="modal" onClick={closeModal}>
                <div
                  className="modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Botón de cierre */}
                  <button className="close-button" onClick={closeModal}>
                    ×
                  </button>
                  <img
                    src={modalImage}
                    alt="Imagen expandida"
                    className="modal-img"
                  />
                </div>
              </div>
            )}
          </div>
        </Modal>
        {/* Modal para Ver Más Datos */}

        <div className="tabla-minimisada flex__column">
          {Array.isArray(users) && users.length > 0 ? (
            users.map((user, index) => (
              <div className="usuario-pendiente radius__5px">
                <div className="usuario-principales">
                  <div className="flex__column first__font">
                    <h1 className="size__14px">{user.name}</h1>
                    <p className="size__14px margin__0">{user.email}</p>
                  </div>
                  <div className="flex__column all__centered">
                    <button
                      className="background__third radius__5px flex__row color__white font__weight500 border__none first__font border__none "
                      onClick={() => abrirImagenModal(user)}
                    >
                      <i class="bi bi-image"></i>
                    </button>
                  </div>
                </div>
                <div className="botones-aprobacion width__fullp flex__row">
                  {" "}
                  <button
                    onClick={() => {
                      aprobarUsuario(user.id, true);
                      handleSendEmail(
                        user?.id,
                        "Tu usuario ha sido aprobado para participar en el evento. Te esperamos."
                      );
                    }}
                    className={`${
                      user.is_approved === true
                        ? "background__exito color__white"
                        : "background__disabled color__icons border__icons1px"
                    } width__fullp acciones-aprobacion  border__none  radius__5px size__18px`}
                  >
                    <i class="bi bi-check text-success"></i>
                  </button>
                  <button
                    onClick={() => {
                      aprobarUsuario(user.id, false);
                      handleSendEmail(
                        user?.id,
                        "Tu usuario no ha sido aprobado. Intenta registrarte con un nuevo usuario y adjuntar los datos correspondientes."
                      );
                    }}
                    className={`${
                      user.is_approved == false
                        ? "background__fallo"
                        : "background__disabled color__icons border__icons1px"
                    } acciones-aprobacion border__none color__white radius__5px size__18px`}
                  >
                    <i class="bi bi-x text-danger"></i>
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div>
              <p colSpan="7" style={cellStyle}>
                No hay datos disponibles.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TablaUsuarios;
